module.exports = __webpack_public_path__ + "static/media/4ODA17.e760c6d7.jpg";